import { ILevelGeneralData } from './level-general-data';


export const levelDomainData = {
    guid: 'guid',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TLevelDomainData = (typeof levelDomainData)[keyof typeof levelDomainData];

export interface ILevelDomainData extends ILevelGeneralData
{
    [levelDomainData.guid]: string;
    [levelDomainData.deleted]: boolean;
    [levelDomainData.inactive]: boolean;
}

export class LevelDomainData
    implements ILevelDomainData, ILevelGeneralData
{
    [levelDomainData.guid]!: string;
    [levelDomainData.deleted]!: boolean;
    [levelDomainData.inactive]!: boolean;

    private constructor(data: ILevelDomainData) {
        Object.assign(this, data);
    }

    static create(data: ILevelDomainData): ILevelDomainData {
        return new LevelDomainData(data);
    }
}
